import type { ApolloError } from '@apollo/client';
import { type AuthLocationState, BaseQueryErrors } from '@cosuno/authentication-frontend';
import type { GraphQLFormattedError } from 'graphql';
import React from 'react';

import { useTermsAcceptance } from '~/components/Terms/useTermsAcceptance';
import { ERROR_TYPES } from '~/shared/constants';

interface Props {
  error: ApolloError;
  loginState?: AuthLocationState;
}

const isTermsNotAcceptedError = (error: GraphQLFormattedError) =>
  error.extensions?.code === ERROR_TYPES.termsNotAccepted;

const QueryErrors: React.FC<Props> = ({ error }) => {
  const { requestTermsAcceptance } = useTermsAcceptance();
  const { graphQLErrors } = error;

  if (graphQLErrors.some(isTermsNotAcceptedError)) {
    requestTermsAcceptance(graphQLErrors);
    return null;
  }

  return <BaseQueryErrors error={error} />;
};

export default QueryErrors;
